const Internal = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="28" viewBox="0 0 22.51 27.83">
      <g transform="translate(0 2.667) rotate(-8)" fill="#fff" stroke="#000" strokeWidth="1">
        <rect width="19.16" height="25.411" stroke="none" />
        <rect x="0.5" y="0.5" width="18.16" height="24.411" fill="none" />
      </g>
      <g transform="translate(3.255 11.663) rotate(-16)">
        <path
          d="M13.9,2a1.159,1.159,0,0,0-.6-.658,4.2,4.2,0,0,0-3.23-.141l-1.108.4L5.8.042A.409.409,0,0,0,5.474.025L3.586.712a.409.409,0,0,0-.1.717l2,1.44L2.707,3.882,1.674,3.044a.409.409,0,0,0-.4-.067L.269,3.344a.409.409,0,0,0-.245.525L.666,5.63A2.284,2.284,0,0,0,3.593,7L6.046,6.1,5.517,8.179a.409.409,0,0,0,.537.486l1.888-.687a.409.409,0,0,0,.235-.22L9.443,4.866,13.2,3.5A1.168,1.168,0,0,0,13.9,2Zm-9.3-.787,1-.362,2.3,1.14L6.421,2.53ZM12.92,2.73,9,4.157a.409.409,0,0,0-.235.22L7.5,7.269l-1,.362L7.03,5.554a.409.409,0,0,0-.537-.486L3.313,6.226A1.466,1.466,0,0,1,1.435,5.35l-.5-1.377.4-.147,1.033.838a.409.409,0,0,0,.4.067l7.575-2.757a3.383,3.383,0,0,1,2.6.114.348.348,0,0,1-.028.643Z"
          transform="translate(0 0)"
        />
      </g>
    </svg>
  );
};

export default Internal;
